import { getSingularCategoryName } from '@which/shared'

import type { AppliedFilterItem } from '../../../../shared/types'

export const getCategoryInfo = ({
  heading,
  description = '',
  metaDesc,
  categoryName,
  appliedFilters,
  brandName,
}: Props): Header => {
  const maybeAppliedBrandFilter = appliedFilters?.find(
    (filter) => (normaliseBrandLabel(filter.label) === normaliseBrandLabel(brandName) ||
      (filter.filterLabel === 'Brands' && normaliseBrandLabel(filter.value) === brandName)
    )
  )

  return {
    heading: maybeAppliedBrandFilter
      ? `${maybeAppliedBrandFilter.label} ${getSingularCategoryName({
          categoryName,
          transform: true,
        })} reviews`
      : heading,
    description: maybeAppliedBrandFilter ? (metaDesc ?? description) : description,
  }
}

const normaliseBrandLabel = (label: string | undefined) => {
  return label
    ? label
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/-/g, ' ')
        .replace(/&/g, 'and')
        .replace(/_/g, '-')
        .toLowerCase()
    : undefined
}

interface Header {
  heading: string
  description: string
}
interface Props {
  heading: string
  description?: string
  metaDesc?: string
  categoryName: string
  appliedFilters?: AppliedFilterItem[]
  brandName?: string
}
